import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

/**
 * YYYY-MM-DD 포맷의 날짜 타입.
 */
export type AclosetDateType = string;

/**
 * AclosetDateType 타입의 날짜 처리 모듈(시간은 전부 제거됩니다.)
 */
export namespace AclosetDate {
  type CompatibleType = AclosetDateType | dayjs.Dayjs;

  /**
   * 날짜 포맷으로 변환.
   *
   * @deprecated 이 포맷 버려도 될지도...? 기획 확인 후 제거.
   */
  export function format(dateJs: dayjs.Dayjs) {
    return dateJs.format('YYYY-MM-DD');
  }
}

/**
 * 매개변수로 받은 날짜에 타임존을 추가합니다.
 * dayjs.tz("2013-11-18 11:55:20", "America/Toronto")
 * // '2013-11-18T11:55:20-05:00'
 */
export function addTimezoneToDate(date?: Dayjs) {
  if (date == null) {
    return undefined;
  }
  return dayjs(date).tz().format();
}
